// Where a dropdown list is drawn when it is rendered on <body>.
//
// The lists have to leave the dialog — a scrollable modal clips anything
// absolutely positioned inside it, so a long list was cut off at the dialog's
// edge. Rendering on <body> fixes that, but vue-select then places the list
// using document coordinates and adds the page's scroll offset. A modal opens
// over a page that is usually scrolled, so the list landed hundreds of pixels
// below the field it belongs to.
//
// Positioning it against the viewport instead removes the offset from the
// equation: the list sits under its field, wherever the page happens to be.

export function dropdownBelowField(dropdownList, component) {
  const toggle = component?.$refs?.toggle;
  if (!toggle || !dropdownList) {
    return;
  }
  const rect = toggle.getBoundingClientRect();
  // Enough room to be useful even in a cramped spot; the list scrolls inside.
  const below = window.innerHeight - rect.bottom - 16;
  const openUpwards = below < 160 && rect.top > below;

  dropdownList.style.position = "fixed";
  dropdownList.style.left = `${Math.round(rect.left)}px`;
  dropdownList.style.width = `${Math.round(rect.width)}px`;
  dropdownList.style.zIndex = "4000";

  if (openUpwards) {
    // No space underneath — hang it above the field rather than off-screen.
    dropdownList.style.top = "auto";
    dropdownList.style.bottom = `${Math.round(
      window.innerHeight - rect.top + 4
    )}px`;
    dropdownList.style.maxHeight = `${Math.round(
      Math.min(320, rect.top - 16)
    )}px`;
  } else {
    dropdownList.style.bottom = "auto";
    dropdownList.style.top = `${Math.round(rect.bottom + 4)}px`;
    dropdownList.style.maxHeight = `${Math.round(Math.min(320, below))}px`;
  }
}
